import { render, staticRenderFns } from "./PaymentRecord.vue?vue&type=template&id=164dc3e2&scoped=true&"
import script from "./PaymentRecord.vue?vue&type=script&lang=js&"
export * from "./PaymentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164dc3e2",
  null
  
)

export default component.exports